import { inject } from '@angular/core';
import { ConfigLoaderService } from '../services/config-loader.service';
import { ApiKey } from '../interceptors/base-url.interceptor';

// 改為函數來動態取得 API URLs
export function getApiBaseUrls(): Partial<Record<ApiKey, string>> {
  const configLoader = inject(ConfigLoaderService);
  return configLoader.getApiBaseUrls() || {};
}

// 保留原有的匯出以維持相容性，但改為動態取得
export const API_BASE_URL: Partial<Record<ApiKey, string>> = {};

// 以後新增end point, 請以 /xxxxxx/xxxxxx 格式新增 得以讓interceptor抓到
export const API_ENDPOINTS = {
  /**登入、註冊**/
  LOGIN: '/member/sessions', // 登入(CB-001)
  LOGIN_SEND_OTP: '/notify/otpsessionlogins', // 登入發送OTP(CB-002)
  LOGIN_VALIDATE_OTP: '/validation/otpverificationlogins', // 登入驗證OTP(CB-003)
  CHECK_IF_REGISTERED: '/member/checkifregistered', // 查詢該身分證字號是否為已註冊為會員(CB-051)
  OTP_SESSION_REGISTERS: '/notify/otpsessionregisters', // 發送/重新發送 OTP 驗證碼至手機/信箱(CB-004)
  OTP_VERIFY_REGISTERS: '/validation/otpverificationregisters', // 驗證 OTP 驗證碼(CB-005)
  VERIFY_EMAIL_REGISTERED: '/member/verifyemailregistered', // 註冊查詢是否為已存在信箱(CB-050)
  CREATE_MEMBER: '/member/member', // 檢核通過後新增會員(CB-052)
  RESET_PASSWORD: '/member/changepassword', // 重設密碼(CB-029)
  REFRESH_SESSIONS: '/member/refreshsessions', // 延長 token 有效時間(CB-088)
  SESSIONS_LOGOUT: '/member/sessionslogout', // 使用者登出(CB-090)
  GET_DUPLICATE_SESSIONS: '/member/getduplicatesessions', // 取得異地登入token(CB-092)
  FORGET_PASSWORD: '/notify/sendforgotpasswordlink', // 忘記密碼發送email(CB-060)

  MAINTENANCE_STATUS: '/maintenance/status', // 維護狀態查詢
  /**個人預約**/
  PROGRESSIVE_VERIFICATION: '/validation/progressiveverification', // 個人漸進式登入(CB-064)
  CHECK_LOCATIONS: '/appointment/checklocations', // 查詢健檢中心，企業需帶 HIS 公司代碼 (CB-041)
  QUESTIONNAIRE_RESPONSES: '/member/questionnaireresponses', // 取得個人、家族、自覺症狀健調表表格欄位 (CB-043)
  BONE_QUESTIONNAIRE_RESPONSES: '/member/getBoneFormsData', // 取得肌肉骨骼症狀調查表
  GET_USER_PLAN: '/healthcheckplan/userplanresult', // 查詢個人方案結果(CB-046)
  CHECK_SUGGESTIONS_BUNDLE: '/healthcheckplan/checksuggestionsbundle', // 查詢加選項目(CB-047)
  REQUIRED_ITEMS: '/appointment/requireditems', //必檢(換項)項目調整(CB-079)
  ELIGIBILITY_QUESTIONNAIRE_FIELDS:
    '/healthcheckplan/eligibilityquestionnairefields', // 查詢合適性問卷表格欄位(CB-048)
  ELIGIBILITY_FORMTEMP: '/appointment/eligibilityformtemp', // 儲存合適性問卷(暫存檔)(CB-078)
  CHECK_REMINDER: '/healthcheckplan/checkreminders', // 查詢檢查提醒(CB-049)
  APPOINTMENT_HISTORY: '/appointment/appointmenthistory', // 查詢預約資料狀態(CB-057)
  CHECKUP_SETTINGS: '/appointment/checkupsettings', // 查詢檢查相關資料欄位(CB-069)
  AVAILABLE_DATES: '/appointment/availabledates', // 查詢可預約之日期(CB-013)
  CONFIRM_APPOINTMENT: '/appointment/confirmappointment', // 送出資料進行預約(CB-056)
  CALENDAR: '/member/calendar', // 查詢個人健檢行事曆(CB-006)
  CHECK_PLAN: '/healthcheckplan/plans', // 查詢我的預約資訊 (CB-007)
  DISCOUNTRATES: '/appointment/discountrates', // 查詢活動折扣率(CB-089)
  DOWNLOAD_USER_PLAN: '/report/downloaduserplan', // 下載個人化方案比較表(CB-045)
  QUESTIONNAIRE_TEMPS: '/appointment/questionnairetemps', // 查詢健調表體況暫存紀錄(CB-021)
  

  /**企業預約**/
  VERIFY_ENTERPRISE_INFO: '/validation/verifyenterpriseinfo', // 驗證企業資訊(CB-040)
  COMPANY_PROGRESSIVE_REGISTRATION: '/validation/companyprogressiveregistration', // 企業漸進式註冊驗證(CB-068)
  CHECK_ENTERPRISE_AVAILABLE_TIME: '/validation/checkenterpriseavailabletime', // 查詢企業預約資料狀態(CB-039)
  ENTERPRISE_PLAN: '/healthcheckplan/enterpriseplans', // 查詢企業健檢方案(CB-033)
  COMPARE_PLAN: '/healthcheckplan/compareplans', // 方案比較(CB-030)
  CHECK_SUGGESTIONS_ENTERPRISE: '/healthcheckplan/checksuggestionsenterprise', // 查詢推薦加選項目(CB-034)
  BUSINESS_CHECKUP_SETTINGS: '/appointment/enterprisecheckupsettings', // 查詢企業檢查相關資料欄位(CB-074)
  BUSINESS_AVAILABLE_DATES: '/appointment/corporateavailabledates', // 企業查詢可預約之日期(CB-066)
  BUSINESS_CONFIRM_APPOINTMENT: '/appointment/corporateappointments', // 企業確認預約(CB-065)改和個人共用CB-056
  DOWNLOAD_ENTERPRISE_PLANS: '/report/downloadenterpriseplans', // 下載企業方案比較表(CB-031)

  /**會員中心**/
  GET_MEMBER_INFO: '/member/me', // 查詢會員資料(CB-009)
  GET_ALL_REPORTS: '/report/allreports', // 查詢所有報告(CB-023)
  LATEST_REPORT: '/report/latest', // 查詢客戶最新報告資料(CB-054)
  REPORT_HISTORY: '/report/history', // 查詢客戶檢項歷年紀錄(CB-055)
  DOWNLOAD_REPORT: '/report/sendreport', // 下載報告(CB-024)
  MODIFY_NAME: '/member/name', // 修改姓名(CB-071)
  SAVE_PHONE: '/member/phone', // 驗證 OTP 及儲存手機(CB-025)
  MODIFY_EMAIL: '/member/email', // 驗證 OTP 及儲存信箱(CB-027)
  VERIFY_CURRENT_PASSWORD: '/member/verifycurrentpassword', // 原密碼驗證(CB-028)
  HEALTH_CHECK_PLAN: '/healthcheckplan/plans', // 查詢健檢方案及預約資訊(CB-007)
  SAVE_QUESTIONNAIRE: '/appointment/completeedit', // (CB-022)
  CANCEL_APPOINTMENT: '/appointment/cancelappointmentinfo', // 取消預約(CB-016)
  MODIFY_PERSONAL_HEALTH_CHECK_INFO: '/appointment/personalheathcheckinfo', // 個人-修改預約資訊(CB-019)
  MODIFY_BUSINESS_HEALTH_CHECK_INFO: '/appointment/corporatehealthcheckinfo', // 企業-修改預約資訊(CB-072)
  DOWNLOAD_PLAN: '/report/downloadplan', // 下載確認方案表(CB-008)
  DOWNLOAD_QUESTIONNAIRE_RESPONSES: '/member/questionnaireresponses', //  查詢各項表單、問卷紀錄(CB-043)
  SUBMIT_QUESTIONNAIRE: '/appointment/completeedit', //  查詢各項表單、問卷紀錄(CB-043)
  GET_CONSENTS:'/appointment/consents', //  查詢各項表單、問卷紀錄(CB-043)'
  /**聊天機器人**/
  AI_CHATBOT: '/appointment/aichatbot', // CB-094 發送生成 AI 回覆的任務

  /**報名流程**/
  GET_CONSENT_STATUS: '/appointment/consentstatus', //  查詢同意書狀態(CB-011)
};

export const API_PARAMS = {
  YES: 'Y',
  NO: 'N',
  GENDER: {
    MALE: 'M',
    FEMALE: 'F',
  },
  PHONE: 'cell',
  EMAIL: 'email',
  IDENTITY: {
    EMPLOYEE: '0', // 員工本人
    EMPLOYEE_DEPENDENTS: '1', // 員工眷屬
  },
  RESERVATION_TYPE: {
    PERSONAL: '1', // 個人預約
    COMPANY: '2', // 企業預約
  },
  FEMALE_STATUS: {
    NONE: 'false', // 無
    PREGNANCY: 'true', // 目前已懷孕、可能懷孕，或正在進行生殖醫療
    POSTPARTUM_BREASTFEEDING: 'breastfeeding', // 產後哺乳中
  },
  QUESTIONNAIRE_TYPE_CODE: {
    PERSONAL: 'personalhistory', // 個人病史
    FAMILY: 'familyhistory', // 家族病史
    SUBJECTIVE_SYMPTOMS: 'subjective_symptoms', // 自覺症狀
  },
  QUESTIONNAIRE_DISEASE_PREFIX: {
    // 勾選症狀value前綴
    PERSONAL: '既往病史_',
    FAMILY: '家族病史_',
    SUBJECTIVE_SYMPTOMS: '自覺症狀_',
  },
  CHECKUP_SETTINGS_DATATYPE: {
    ALL: '0', // 全部
    LANGUAGE: '1', // 報告語言
    CLOTHES_SIZE: '2', // 健檢服尺寸
    DIET: '3', // 餐食選項
  },
  PRE_EXAM_INFO_DELIVERY_METHOD: {
    // 檢前資料寄送方式
    INDIVIDUAL: {
      code: '1',
      name: '個別寄送',
    },
    AGENT: {
      code: '2',
      name: '承辦領取',
    },
    NOT_INDIVIDUAL: {
      code: '3',
      name: '不需寄送',
    },
  },
  DELIVERY_METHOD: {
    // 檢查報告領取方式
    DOMESTIC: {
      code: '0',
      name: '郵寄國內',
    },
    INDIVIDUAL: {
      code: '1',
      name: '個別寄送',
    },
    FOREIGN: {
      code: '9',
      name: '郵寄國外',
    },
    AGENT: {
      code: '2',
      name: '承辦領取',
    },
    NOT_INDIVIDUAL: {
      code: '3',
      name: '不需寄送',
    },
    OTHER: {
      code: '99',
      name: '不需寄送',
    },
    SELF: {
      code: '01',
      name: '本人',
    },
    NOT_SELF: {
      code: '02',
      name: '非本人',
    },
  },
  EXAM_REPORT_LANGUAGE: {
    CHINESE: {
      code: '1',
      name: '繁體中文',
    },
    ENGLISH: {
      code: '2',
      name: '英文',
    },
    JAPANESE: {
      code: '3',
      name: '日文',
    },
  },
  DAY_TYPE: {
    HALF_DAY: {
      code: '1',
      name: '半日',
    },
    FULL_DAY: {
      code: '2',
      name: '全日',
    },
  },
  CLOTHES_SIZE: {
    MALE: {
      M: {
        code: '01',
        name: 'M',
      },
      L: {
        code: '02',
        name: 'L',
      },
      XL: {
        code: '03',
        name: 'XL',
      },
      LL: {
        code: '04',
        name: '2L',
      },
      LLL: {
        code: '05',
        name: '3L',
      },
      LLLL: {
        code: '06',
        name: '4L',
      },
      LLLLL: {
        code: '07',
        name: '5L',
      },
    },
    FEMALE: {
      S: {
        code: '01',
        name: 'S',
      },
      M: {
        code: '02',
        name: 'M',
      },
      L: {
        code: '03',
        name: 'L',
      },
      XL: {
        code: '04',
        name: 'XL',
      },
      LL: {
        code: '05',
        name: '2L',
      },
      LLL: {
        code: '06',
        name: '3L',
      },
      LLLL: {
        code: '07',
        name: '4L',
      },
    },
  },
  DIET: {
    BREAKFAST: {
      CHINESE_VEGETARIAN: {
        code: '01',
        name: '中式/素食',
      },
      CHINESE_NON_VEGETARIAN: {
        code: '02',
        name: '中式/葷食',
      },
      WESTERN_VEGETARIAN: {
        code: '03',
        name: '西式/素食',
      },
      WESTERN_NON_VEGETARIAN: {
        code: '04',
        name: '西式/葷食',
      },
    },
    LUNCH: {
      CHINESE_VEGETARIAN: {
        code: '01',
        name: '中式/素食',
      },
      CHINESE_NON_VEGETARIAN: {
        code: '02',
        name: '中式/葷食',
      },
      WESTERN_VEGETARIAN: {
        code: '03',
        name: '西式/素食',
      },
      WESTERN_NON_VEGETARIAN: {
        code: '04',
        name: '西式/葷食',
      },
    },
  },
  NATIONALITY: {
    TW: '01',
    OTHERS: '99', // 其他國籍
  },
};
